import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable, tap } from "rxjs";

import { StorageService } from '@coin-depo-core/storage';
import { ApiService } from "@coin-depo/http";
import { AdvertisementFacade } from '@coin-depo-core/advertisement';

import type { GetAdsResponse, BaseApiRequest } from '@coin-depo-types';
import { AUTH_SERVICE_TOKEN, AuthFacade } from "@coin-depo-core/auth";


@Injectable({ providedIn: 'root'})
export class AdvertisementService implements AdvertisementFacade {
   private addLtv$ = new BehaviorSubject<number>(
    this.storage.get('addLtv', 0)
   )
  cachedAddLtv$ = this.addLtv$.asObservable();

  constructor(
    private storage: StorageService,
    @Inject(AUTH_SERVICE_TOKEN) private auth: AuthFacade,
    private advertisementApi: ApiService
  ) {}

  getAds(): Observable<GetAdsResponse > {
    const data: BaseApiRequest = {
        username:this.auth.userData.email,
        client_token:this.auth.accessToken
    }
    return this.advertisementApi.getAds(data).pipe(
        tap(res => {
            if (res.status === 'success') {
                this.setAdLtv(res.ltv)
            }
        })
    )
  }

  private setAdLtv(ltv: string) {
    this.addLtv$.next(Number(ltv));
    this.storage.set('addLtv', ltv);
  }
}
